module.exports = __webpack_public_path__ + "media/images/lp_04-a24a19c8526680664500e471a2837aa5.webp";